import React, { Component } from 'react'
import { Column } from 'hedron';
import styled from 'styled-components';
import ds from 'designsystem';
import { inject, observer } from 'mobx-react';
import DIVIDED_SECTION_ORDER from 'common/consts/dividedSectionOrder';
import { media } from 'common/responsive';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES } from 'animations/Animations';
import Image from 'elements/Image';
import BlogArticleBoldText from 'elements/BlogArticleBoldText';
import { safeHtmlWithBr } from 'common/methods/string';

/* eslint-disable react/prop-types */

const SectionWrapper = styled.div`
    margin:${ds.get('metrics.base')} auto;
    ${media.desktop`
      display:flex;
      flex-direction:row;
      width:100%;
      width:160%;
      margin:${ds.get('metrics.l')} auto;
      margin-left:${({ order }) => (order ? '-36%' : '-15%')};
    `};
`;

const StyledColumn = styled(Column)`
  order: ${({ order }) => (order ? '0' : '1')};
`;

@inject('windowStore')
@observer
export default class DivicedBlogSection extends Component {
  render() {
    const {
      data: {
        cite,
        image,
        order,
      },
      windowStore,
    } = this.props;
  
    const imageFirst = order === DIVIDED_SECTION_ORDER.IMAGE_CITE;
  
    return (
      <SectionWrapper
        order={imageFirst ? 1 : 0}
      >
        <StyledColumn
          lg={6}
          lgShift={!imageFirst ? 1 : 0}
          order={imageFirst ? 1 : 0}
        >
          <Fade
            left
            distance={`${FADE_VALUES.BOX.SMALL}`}
            delay={FADE_VALUES.DELAY.SMALL}
          >
            <Image
              src={windowStore.adjustImageSize(image)}
            />
          </Fade>
        </StyledColumn>
        <Column lg={4} lgShift={imageFirst ? 1 : 0}>
          <Fade
            right
            distance={`${FADE_VALUES.BOX.SMALL}`}
            delay={FADE_VALUES.DELAY.SMALL}
          >
            <BlogArticleBoldText
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(cite),
              }}
            />
          </Fade>
        </Column>
      </SectionWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/DividedBlogSection/index.jsx